module.exports = __webpack_public_path__ + "2cc5f96f18259465ddf23b0ce320f7e2.png";